import React from 'react';
import { useDrawer } from '../../Common/SidebarDrawer/SidebarDrawer';
import MixtureForm from './MixtureForm';

const CreateMixtureForm = ({ setTableData, onCloseModal }) => {
    const closeModal = () => {
        // Rechercher le parent modal le plus proche et le fermer
        console.log('close')
        if (onCloseModal) {
            onCloseModal();
        } else {
            const modal = document.querySelector('[role="dialog"]');
            if (modal && typeof modal.close === 'function') {
                modal.close();
            }
        }

    };

    return (
        <MixtureForm
            mode="create"
            onClose={closeModal}
            setTableData={setTableData}
        />
    );
};

export default CreateMixtureForm;
